var _module = require('../../components/module');
var simpleCypher = require('../../../libs/simple-cypher');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');
require('../activity-feed');
require('../analytics');
require('../user');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$shareModal', [
    '$log',
    '$uibModal',
    '$user',
    '$activityFeed',
    '$analytics',

    function $shareModalService($log, $uibModal, $user, $activityFeed, $analytics) {
        /*
        @function openShareModal
        @param {String} url - The url you want to share
        @param {Object} listing
        @param {String} filterId
        @param {Object} [options]
        @param {String} [options.facebookUrl] - An alternative url for Facebook
        @param {String} [options.twitterUrl] - An alternative url for Twitter
        */
        return function openShareModal(url, listing, filterId, options) {
            options = options || {};

            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: ['$scope', function shareModalCtrl($scope) {
                    var link = '';

                    // Functions
                    $scope.share = function share(type) {
                        $scope.$close();

                        // Facebook
                        if(type === 'facebook') {
                            link = 'http://www.facebook.com/sharer.php?u=' + (options.facebookUrl || url);

                            window.open(link);
                        }
                        // Twitter
                        else if(type === 'twitter') {
                            var text = 'Check out this property for sale! What do you think about it?';
                            link = 'https://twitter.com/share?url=' + (options.twitterUrl || url) + '&text=' + text;

                            window.open(link);
                        }
                        // Email
                        else if(type === 'email') {
                            var subject = 'Check out this property for sale...';
                            var body = ['Hey There,', '%0D%0A%0D%0A', 'Check out this property for sale! What do you think about it?', '%0D%0A%0D%0A', url].join('');
                            var email = '';
                            link = 'mailto:' + email +
                                '?subject=' + subject +
                                '&body=' + body;

                            window.open(link, '_self');
                        }

                        if($user.account_type !== 'guest') {
                            $activityFeed.add({
                                avatar: 'initials',
                                type: 'lead',
                                name: 'benoit_listing_shared_by_user',
                                userId: $user.affiliateId,
                                meta: {
                                    benoitPartnerId: $user.affiliate.benoitPartnerId,
                                    benoitUserId: $user.id,
                                    name: $user.full_name,
                                    first_name: $user.first_name,
                                    last_name: $user.last_name,
                                    address: listing.address,
                                    listingId: simpleCypher.decode(listing.id).id,
                                    listing_source: listing.listing_source,
                                    filterId: filterId,
                                    source: type
                                }
                            });
                        }

                        $analytics.eventTrack('nest.me Listing Shared', {
                            'Share Option': type,
                            'Match Score': listing.match_score,
                            Address: listing.address,
                            'Sq Ft': listing.home_size,
                            Bed: listing.beds,
                            Bath: listing.baths,
                            Status: listing.listing_status,
                            'Filter ID': filterId,
                            Price: listing.price
                        });
                    };
                }],
                backdrop: true,
                windowClass: 'share-modal'
            });

            return modal.result;
        };
    }
]);
